import "./styles.css";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import TechStack from "./componenets/techStack";
import About from "./componenets/about";
import Contact from "./componenets/contact";
import Navbar from "./componenets/commonComp/navbar";
import Header from "./componenets/commonComp/header";
import Experience from "./componenets/projects";
import Resume from "./componenets/resume";
import Eduction from "./componenets/eduction";
import Hobbies from "./componenets/hobbies";
import Social from "./componenets/social";
import NotFound from "./componenets/commonComp/errorPage";
import Footer from "./componenets/commonComp/footer";
import Certification from "./componenets/certification";
import HeroSection from "./componenets/heroSection";
function App() {
  return (
    <div className="App font-mono bg-background dark:bg-background-dark text-text-light">
      {/* <Header /> */}
      <Navbar />
      {/* <div className="bg-background text-text dark:bg-background-dark dark:text-text-light">
        <h1 className="text-3xl font-mono text-primary">Hi, I'm Pranjal</h1>
        <p className="text-accent">Frontend Developer</p>
      </div>*/}
      <HeroSection />
      <About />
      <Experience />
      <TechStack />
      {/* <Skills /> */}

      <Certification />
      <Contact />
      {/* 
      <Resume />
      <Contact /> */}
      {/* <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/certification" element={<Certification />} />
        <Route path="/eduction" element={<Eduction />} />
        <Route path="/hobbies" element={<Hobbies />} />
        <Route path="/social" element={<Social />} />
        <Route path="*" element={<NotFound />} />
      </Routes> */}
      {/* </BrowserRouter> */}
      {/* <Footer /> */}
      {/* </Header> */}
    </div>
  );
}

export default App;
